/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'AlternateProducts.title',
    defaultMessage: 'Alternates'
  },
  partNumber: {
    id: 'AlternateProducts.AlternateProduct.partNumber',
    defaultMessage: 'Part #'
  },
  selectDealer: {
    id: 'AlternateProducts.AlternateProduct.selectDealer',
    defaultMessage: 'Set a location to see availability'
  },
  availability: {
    id: 'AlternateProducts.AlternateProduct.availability',
    defaultMessage:
      'Available {isAvailable, select, true {today} other {in 2-5 Days}}'
  },
  availabilityOverride: {
    id: 'AlternateProducts.AlternateProduct.availability.override',
    defaultMessage: 'Available next day'
  }
});
